import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=306adbad&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"
import style0 from "./Share.vue?vue&type=style&index=0&id=306adbad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306adbad",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgFacebook: require('/app/components/svg/Facebook.vue').default,SvgTwitter: require('/app/components/svg/Twitter.vue').default,SvgLinkedin: require('/app/components/svg/Linkedin.vue').default,SvgMail: require('/app/components/svg/Mail.vue').default})
